import setIntersection from './setIntersection';

const isSameSize = <T>(setA: Set<T>, setB: Set<T>): boolean => setA.size === setB.size;

export default <T>(setA: Set<T>, setB: Set<T>): boolean =>
  isSameSize(setA, setB) && isSameSize(setA, setIntersection(setA, setB));
